import AuthorizationHelper from '@auth/services/authorization.helper';

const routes = [
  {
    path: 'sectors',
    name: 'admin-sectors',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.sectors],
    },
    component: () =>
      import(/* webpackChunkName: "admin-sectors" */ '@sectors/pages/sectors/sectors.vue'),
  },
];

export default routes;
